import { render } from "./CommentCompDIY.vue?vue&type=template&id=344df620&scoped=true"
import script from "./CommentCompDIY.vue?vue&type=script&lang=js"
export * from "./CommentCompDIY.vue?vue&type=script&lang=js"

import "./CommentCompDIY.vue?vue&type=style&index=0&id=344df620&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344df620"]])

export default __exports__